import { useEffect, useState } from "react";
import { convertMonth } from "components-base/salidas/functions";
import PedidosTable from "./components/PedidosTable";
import { getAllPedidos } from "./functions";
import { months } from "utils/apis";
import TabComponent from "components-base/Tab/Tab";
import {
  Autocomplete,
  TextField,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";

const Pedidos = () => {
  const years = [
    { id: 1, label: 2023 },
    { id: 2, label: 2024 },
    { id: 3, label: 2025 },
    { id: 4, label: 2026 },
    { id: 5, label: 2027 },
    { id: 6, label: 2028 },
    { id: 7, label: 2029 },
    { id: 8, label: 2030 },
  ];
  const currentMonth = new Date().getMonth();
  const añoActual = new Date().getFullYear();
  const [pedidos, setPedidos] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [refreshP, setRefreshP] = useState(false);
  const data = years.filter((item) => item.label === añoActual);
  const [selectedOption, setSelectedOption] = useState(data[0]);

  useEffect(() => {
    const fetchDataPedidos = async () => {
      let pedidos = await getAllPedidos();
      let _pedidos = await convertMonth(pedidos);
      setPedidos(_pedidos);
    };
    fetchDataPedidos();
  }, [refreshP]);

  useEffect(() => {
    if (pedidos) {
      let tabsArray = months.map((month) => {
        let dataMonth = pedidos.filter((item) => item.monthName === month);
        let dataYear = dataMonth.filter(
          (item) => item.year === selectedOption.label
        );
        return {
          label: month,
          component: (
            <PedidosTable
              setRefresh={setRefreshP}
              refresh={refreshP}
              key={month}
              data={dataYear}
            />
          ),
        };
      });
      setTabs(tabsArray);
    }
  }, [pedidos, selectedOption]);

  const handleChange = (event, newValue) => {
    setSelectedOption(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: 3,
        borderRadius: 3,
        bgcolor: "background.paper",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
        minHeight: 300,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          pb: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
          width: "100%",
        }}
      >
        <Autocomplete
          disablePortal
          options={years}
          value={selectedOption}
          getOptionLabel={(option) => String(option.label)}
          onChange={handleChange}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          size="small"
          sx={{ width: 180 }}
          renderInput={(params) => (
            <TextField {...params} label="Año" size="small" />
          )}
        />
      </Box>

      {/* Contenido con Tabs */}
      {tabs.length !== 0 ? (
        <Box sx={{ mt: 1 }}>
          <TabComponent tabsElement={tabs} month={currentMonth} />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
            gap: 2, 
          }}
        >
          <CircularProgress color="primary" />
          <Typography>Cargando datos...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Pedidos;
